<template>
  <div class="app-review-modal">
    <!-- <div class="close" @click="close()">
      <svg width="12" height="12" viewBox="0 0 12 12" fill="none" xmlns="http://www.w3.org/2000/svg">
        <path d="M0.22037 1.28002C-0.0734566 0.986194 -0.0734566 0.511071 0.22037 0.22037C0.514196 -0.0703308 0.98932 -0.0734566 1.28002 0.22037L6 4.94035L10.72 0.22037C11.0138 -0.0734566 11.4889 -0.0734566 11.7796 0.22037C12.0703 0.514196 12.0735 0.98932 11.7796 1.28002L7.05965 6L11.7796 10.72C12.0735 11.0138 12.0735 11.4889 11.7796 11.7796C11.4858 12.0703 11.0107 12.0735 10.72 11.7796L6 7.05965L1.28002 11.7796C0.986194 12.0735 0.511071 12.0735 0.22037 11.7796C-0.0703308 11.4858 -0.0734566 11.0107 0.22037 10.72L4.94035 6L0.22037 1.28002Z" fill="white"/>
      </svg>
    </div> -->

    <div class="app-review-inner">
      <div class="app-review-icon">
        <base-svg svg="meta-celebrate" height="3rem" />
      </div>

      <div class="review-stack">
        <h3 v-html="getHeading"></h3>
        <p v-html="getByline"></p>
      </div>

      <button @click="takeAction()" v-html="getButton"></button>

      <button class="btn ghost" @click="close()">Not right now</button>
    </div>
  </div>
</template>

<script>
  export default {
    props: {
      opts: {
        type: Object,
        default: null
      },
    },

    computed: {
      hasApp() {
        return this.$store.getters.hasApp;
      },
      getHeading() {
        if (this.opts.rating < 5) {
          return `Yikes. 😬 Sorry!`
        } else {
          return `Wow 🥰 Thanks!`
        }
      },

      getByline() {
        if (this.opts.rating < 5) {
          return `What would make that 5 Stars?<br/>We're a tiny team, keen to improve.`
        } else {
          return this.hasApp ? 
            `Could you write an AppStore review?<br/>It would mean the world to us.` :
            `Would you consider inviting some of your friends to try Nourish?`
        }
      },

      getButton() {
        if (this.opts.rating < 5) {
          return `I'll tell you…`
        } else {
          return `Yes, I'd love to help.`
        }
      }
    },

    methods: {
      close() {
        this.$emit('close');
      },

      takeAction() {
        const userEmail = this.$userEngine.get?.details?.email || '(unknown)';
        const screenName = this.$userEngine.get?.screen_name || 'unknown';

        if (this.opts.rating < 5) {
          this.EventBus.$emit('track:event', {
            event: 'feedback-fewer-notes',
            props: { mode: this.opts.rating},
            detail: { detail_char: this.opts.rating },
          });
          
          // Trigger typeform
          const typeForm = `https://form.typeform.com/to/hyrgECPO?email=${userEmail}&rating=${this.opts.rating}`;
          
          if (this.hasApp) {
            this.EventBus.$emit("appCallback", {
              type: 'storyCallback',
              data: {
                browser: 'onesub',
                publisher: 'Nourish',
                articleURL: typeForm,
              }
            });
          } else {
            window.open(typeForm, 'typeForm');
          }

        } else {
          if (this.hasApp) { 
            this.EventBus.$emit('track:event', {
              event: 'feedback-five-notes',
              props: { mode: 'Form' },
              detail: { detail_char: 'Form' },
            });
            
            // Trigger app store
            this.EventBus.$emit("appCallback", {
              type: 'reviewCallback',
              data: {
                type: 'review'
              }
            });
          } else {
            this.EventBus.$emit('track:event', {
              event: 'feedback-five-notes',
              props: { mode: 'Invite' },
              detail: { detail_char: 'Invite' },
            });

            this.$router.push(`/~${screenName}/invite`);
          }

        }

        this.close();
      }
    },
  }
</script>

<style lang="scss" scoped>
  @import 'src/assets/scss/v5.scss';

  .app-review-modal {
    position: absolute;
    bottom: 0;
    left: 0;
    right: 0;
    display: flex;
    flex-direction: column;
    align-items: center;
    justify-content: space-between;
    gap: 0.5rem;
    width: 100%;
    color: white;
    background-color: $neutral-100;
    background: radial-gradient(circle at bottom right, rgba($green-tone-6, 1), rgba($neutral-100, 1) 70%);
    border-top: 1px solid rgba($neutral-400, 0.25);
    border-top-left-radius: 25px;
    border-top-right-radius: 25px;
    max-width: 900px;
    margin: 0 auto;
    padding-bottom: calc(env(safe-area-inset-bottom) + 2rem);

    .close {
      display: flex;
      align-items: center;
      justify-content: center;
      align-self: flex-end;
      width: 44px;
      height: 44px;
      background: black;
      border: 1px solid rgba($neutral-400, 0.2);
      border-radius: 500px;
      cursor: pointer;
      margin: 1.5rem 1.5rem 0 0;
    }

    .app-review-inner {
      display: flex;
      flex-direction: column;
      align-items: center;
      gap: 1rem;
      padding: 4rem 1.5rem 5rem 1.5rem;
      max-width: 500px;
      margin: 0 auto;
      text-align: center;

      .app-review-icon {
        margin-bottom: 1rem;

        svg {
          fill: $green-tone-3;
        }
      }

      .review-stack {
        display: flex;
        flex-direction: column;
        gap: 0;
        margin-bottom: 2rem;
      }

      h3 {
        font-family: 'Circular';
        font-weight: bold;
        font-size: 1.8rem;
        line-height: 110%;
        color: $green-tone-3;
        text-wrap: balance;
      }

      p {
        font-size: 1.1rem;
        text-wrap: balance;
        margin-top: 1rem;
      }

      button {
        background: $green-tone-3;

        &:disabled {
          background: rgba($green-tone-3, 0.25);
        }

        &.ghost {
          background: transparent;
          margin-top: 2rem;
        }
      }
    }
  }
</style>    